import { Switch } from "../ui/switch";
import { Slider } from "../ui/slider";
import { Label } from "../ui/label";
import { Input } from "../ui/input";

const STYLES = [
  ["cinematic", "Cinematográfico", "bg-black", "font-serif text-[#E8C47C]"],
  ["minimal", "Minimalista", "bg-stone-100", "font-light text-zinc-900"],
  ["documentary", "Documental", "bg-zinc-800", "font-anton uppercase text-white border-l-4 border-yellow-400 pl-1"],
  ["corporate", "Corporativo", "bg-[#0B1B33]", "font-semibold text-white border-l-2 border-sky-400 pl-1"],
  ["dynamic", "Dinámico", "bg-zinc-950", "font-anton uppercase text-yellow-400"],
  ["poetic", "Poético", "bg-[#2A1E17]", "font-serif italic text-[#F3D9A4]"],
];

export const TitlePanel = ({ cfg, set }) => {
  const t = cfg.title_screen;
  const upd = (p) => set({ title_screen: { ...t, ...p } });
  return (
    <div className="space-y-4" data-testid="title-panel">
      <div className="flex items-center justify-between"><Label>Añadir pantalla de título al inicio</Label>
        <Switch data-testid="title-enabled-switch" checked={t.enabled} onCheckedChange={(v) => upd({ enabled: v, text: t.text || cfg.title })} /></div>
      {t.enabled && (
        <>
          <div className="grid grid-cols-3 gap-2">
            {STYLES.map(([id, name, bg, txt]) => (
              <button key={id} data-testid={`title-style-${id}`} onClick={() => upd({ style: id })}
                className={`rounded-lg overflow-hidden border text-left transition-colors ${t.style === id ? "border-[#E8C47C]" : "border-white/10 hover:border-white/25"}`}>
                <div className={`${bg} h-12 grid place-items-center`}><span className={`text-[11px] ${txt}`} style={id === "cinematic" || id === "poetic" ? { fontFamily: "Fraunces, serif" } : {}}>Título</span></div>
                <p className="text-[11px] text-zinc-400 px-2 py-1">{name}</p>
              </button>
            ))}
          </div>
          <Input data-testid="title-text-input" value={t.text} onChange={(e) => upd({ text: e.target.value })} placeholder="Título del video" className="bg-zinc-900/60" />
          <Input data-testid="title-subtitle-input" value={t.subtitle} onChange={(e) => upd({ subtitle: e.target.value })} placeholder="Subtítulo (opcional)" className="bg-zinc-900/60" />
          <div className="space-y-2">
            <Label className="text-xs text-zinc-400 flex justify-between">Duración <span className="font-mono-tc text-[#E8C47C]">{t.duration}s</span></Label>
            <Slider data-testid="title-duration-slider" min={2} max={6} step={0.5} value={[t.duration]} onValueChange={([v]) => upd({ duration: v })} />
          </div>
        </>
      )}
    </div>
  );
};
